import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SieveSizeForm from '../../../../components/masters/stoneAttribute/sieveSize/SieveSizeForm';
import SieveSizeTable from '../../../../components/masters/stoneAttribute/sieveSize/SieveSizeTable';
import { fetchSieveSizes, addSieveSize, updateSieveSize, deleteSieveSize, setSieveSizeEdit, clearSieveSizeEdit } from '../../../../redux/actions/masters/stoneAttribute/sieveSize/sieveSizeAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginRight: 0,
};
const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .sieve-size-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .sieve-size-form, .sieve-size-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const SieveSizePage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingSieveSize, formSuccess, formError } = useSelector(state => state.sieveSize || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchSieveSizes());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearSieveSizeEdit());
  };

  const handleSubmit = async (form) => {
    if (editingSieveSize && editingSieveSize.sieve_size_id) {
      await dispatch(updateSieveSize(editingSieveSize.sieve_size_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addSieveSize(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (sieveSize) => {
    dispatch(setSieveSizeEdit(sieveSize));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteSieveSize(id));
  };

  const handleCancel = () => {
    dispatch(clearSieveSizeEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      ss => ss.sieve_size_code === code && (!excludeId || ss.sieve_size_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={{ ...containerStyle, className: 'sieve-size-flex' }}>
        <div style={{ ...tableContainer, className: 'sieve-size-table' }}>
          <SieveSizeTable
            onNew={handleFormReset}
          />
        </div>
        <div style={{ ...formContainer, className: 'sieve-size-form' }}>
          <SieveSizeForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingSieveSize={editingSieveSize}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default SieveSizePage; 